module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [(_vm.loading) ? _c('loading') : [(_vm.error) ? [_c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.error))])] : _vm._e(), (!_vm.error) ? [_c('div', {
    staticClass: "campaign-step-offer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-8"
  }, [_c('div', {
    staticClass: "reach-description hidden-md-up"
  }, [_c('markdown', {
    attrs: {
      "source": _vm.$t('pos.offer.mobile-description', {
        users: _vm.maxReach
      })
    }
  }), _c('div', {
    staticClass: "bottom-mode-switch"
  })], 1), _c('package-slider-box', {
    attrs: {
      "campaign": _vm.campaign,
      "availablePackages": _vm.availablePackages,
      "selectedPackage": _vm.selectedPackage,
      "goalTypes": _vm.goalTypes,
      "packagesArr": _vm.packagesArr,
      "businessCategory": _vm.businessCategory
    }
  }), _c('div', {
    staticClass: "row mt-4"
  }, [_c('div', {
    staticClass: "col-5 push-1 col-md-8 push-md-2 col-lg-4 push-lg-4"
  }, [_c('svg-reach-chart', {
    attrs: {
      "guaranteedReach": _vm.selectedPackage.reach.min,
      "notReached": _vm.maxReach - _vm.selectedPackage.reach.min
    }
  })], 1), _c('div', {
    staticClass: "col-6 hidden-md-up"
  }, [_c('div', {
    staticClass: "center-vertically"
  }, [_c('svg-legend')], 1)]), _c('div', {
    staticClass: "col-12 col-lg-4 push-lg-4"
  }, [(_vm.availableClusters.length > 1) ? _c('div', {
    staticClass: "center-vertically radio-container hidden-md mt-3 mt-md-0 bottom-mode-switch"
  }, [_c('b-form-radio', {
    attrs: {
      "value-field": "fullModeName",
      "options": _vm.availableClusters
    },
    model: {
      value: (_vm.internalMode),
      callback: function($$v) {
        _vm.internalMode = $$v
      },
      expression: "internalMode"
    }
  })], 1) : _vm._e()])])], 1), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('full-info-box', {
    staticClass: "mt-4 mt-md-0",
    attrs: {
      "campaign": _vm.campaign,
      "configuration": "offer.infobox",
      "card": "card",
      "showMore": false
    }
  }, [_c('h5', {
    staticClass: "info-box-header",
    attrs: {
      "slot": "above"
    },
    slot: "above"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.infobox-title')))]), _c('b-btn', {
    staticClass: "btn-back btn-block",
    attrs: {
      "slot": "below",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.goBack($event)
      }
    },
    slot: "below"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.edit-target'))), _c('div', {
    staticClass: "small"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.go-back')))])])], 1), (_vm.availableClusters.length > 1) ? _c('div', {
    staticClass: "right-mode hidden-lg-up hidden-sm-down"
  }, [_c('div', {
    staticClass: "radio-container"
  }, [_c('b-form-radio', {
    attrs: {
      "value-field": "fullModeName",
      "options": _vm.availableClusters
    },
    model: {
      value: (_vm.internalMode),
      callback: function($$v) {
        _vm.internalMode = $$v
      },
      expression: "internalMode"
    }
  })], 1)]) : _vm._e()], 1)]), _c('div', {
    staticClass: "row hidden-sm-down"
  }, [_c('div', {
    staticClass: "col-md-6 col-lg-8"
  }, [_c('svg-legend', {
    staticClass: "mt-2"
  }), (_vm.extralineBottom) ? _c('div', {
    style: ({
      textAlign: 'center',
      fontSize: '97%'
    })
  }, [_vm._v(_vm._s(_vm.extralineBottom))]) : _vm._e(), (_vm.showSpecialAdCategoryDisclaimer) ? _c('div', {
    style: ({
      textAlign: 'center',
      fontSize: '97%'
    })
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.special_ad_category_warning')))]) : _vm._e()], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-md-6 offset-md-6 col-lg-4 offset-lg-8"
  }, [_c('div', {
    staticClass: "btn-confirm-container"
  }, [_c('b-button', {
    staticClass: "btn-confirm btn-block desktop-confirm",
    attrs: {
      "size": "lg",
      "variant": "success",
      "disabled": _vm.selectedPackage.reach.min === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "larger"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.confirm')))]), _vm._v(_vm._s(_vm.$t('pos.offer.move-to-format')))])], 1)])])])]), _c('b-button', {
    staticClass: "btn-confirm btn-block mobile-confirm main-confirm",
    attrs: {
      "size": "lg",
      "variant": "success",
      "disabled": _vm.selectedPackage.reach.min === 0
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "larger"
  }, [_vm._v(_vm._s(_vm.$t('pos.offer.confirm')))]), _vm._v(_vm._s(_vm.$t('pos.offer.move-to-format')))])] : _vm._e()]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67e78d2a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/campaign-offer/CampaignOffer.vue
// module id = 942
// module chunks = 1